import PaymentOrderBatchSection from './PaymentOrderBatchSection';
import PaymentOrderDataSection from './PaymentOrderDataSection';
import PaymentOrderInvoicesSection from './PaymentOrderInvoicesSection';
import PaymentOrderPaymentSection from './PaymentOrderPaymentSection';
import PaymentOrderPreviewSection from './PaymentOrderPreviewSection';
import PaymentOrderSummarySection from './PaymentOrderSummarySection';

const CreatePaymentOrderActiveSection = ({ controller }) => {
  switch (controller.activeSection) {
    case 'batch':
      return <PaymentOrderBatchSection controller={controller} />;
    case 'data':
      return <PaymentOrderDataSection controller={controller} />;
    case 'invoices':
      return <PaymentOrderInvoicesSection controller={controller} />;
    case 'payment':
      return <PaymentOrderPaymentSection controller={controller} />;
    case 'preview':
      return <PaymentOrderPreviewSection controller={controller} />;
    case 'summary':
    default:
      return <PaymentOrderSummarySection controller={controller} />;
  }
};

export default CreatePaymentOrderActiveSection;
